import { Injectable } from '@angular/core';
import {
    MessagingService,
    TranslationsLoadedMessage
} from '../system-services/Messaging.service';

// In our system the translation data is loaded early, but our
// translation service which would normally hold that data  has
// functionality and dependencies. This is a place to hold our
// translation data, but not use the services  built on top of
// that data. It fixes some dependency issues.

@Injectable({
    providedIn: 'root'
})
export class TranslationDataService {
    _data;
    constructor(private messageService: MessagingService) {}

    get data() {
        return this._data;
    }
    set data(value) {
        this._data = value;
        this.messageService.sendMessage(new TranslationsLoadedMessage());
    }
}
